module.exports = __webpack_public_path__ + "img/LOGO.fe88d344.svg";